import { createSlice } from "@reduxjs/toolkit";
import type { AppThemes, ThemeState } from "./types";
import { reducers } from "./reducers";

const getUserMediaTheme = (): AppThemes => {
  const userMedia = window.matchMedia("(prefers-color-scheme: light)");
  if (userMedia.matches) return "light";
  return "dark";
};

const initialState: ThemeState = {
  theme: getUserMediaTheme(),
};

export const themeSlice = createSlice({
  initialState,
  name: "theme",
  reducers: reducers,
});

export const { setTheme } = themeSlice.actions;
